import React, { useEffect, useState } from 'react'
import { Button, Card, Empty, Space, Tag } from 'antd'
import { PlusOutlined } from '@ant-design/icons'
import RoomTable from '../../../components/Rooms/RoomTable'
import { notify } from '../../../components/Customs/NotifyProvider'
import PageLayout from '../../../components/Customs/PageLayout'
import RoomDetail from '../../../components/Rooms/RoomDetail'
import { RoomServices } from '../../../Services/RoomServices'
import { navigate } from '../../../components/Customs/navigation'
import RoomList from '../../../components/Rooms/book/RoomList'
import TitleHead from '../../../components/Customs/TitleHead'


import { canViewModule, canCreateModule, canUpdateModule, canDeleteModule } from '../../../../utils/permissionUtils'

const MODULE_KEY = 'rooms'

const ManageRooms = () => {
  const [rooms, setRooms] = useState([])
  const [selectedRoom, setSelectedRoom] = useState(null)



  const getAllRooms = async () => {
    try {
      const res = await RoomServices.getAllRoom()
      const roomsData = res?.data?.data || res?.data || []
      setRooms(roomsData)

      if (Array.isArray(roomsData) && roomsData.length > 0) {
        const lowestSortRoom = roomsData.reduce((prev, current) => {
          return Number(current?.sort_order ?? Infinity) < Number(prev?.sort_order ?? Infinity)
            ? current
            : prev
        }, roomsData[0])

        setSelectedRoom(lowestSortRoom)
      }
    } catch (error) {
      console.error("Failed to fetch rooms:", error)
      setRooms([])
    }
  }

  useEffect(() => {
    getAllRooms()
  }, [])

  if (!canViewModule(MODULE_KEY)) {
    return <Empty description="No permission to view this page" />
  }

  const handleEditRoom = () => {
    navigate('/edit-room', { state: { room: selectedRoom } })
  }

  const handleDelete = async () => {
    try {
      console.log(selectedRoom.id);
      const request = await RoomServices.deleteRoom(selectedRoom.id)
      if (request.status) {
        notify.success("Deleted!", request.message)
        getAllRooms()
      } else {
        notify.error("Something went wrong!", request.message)
      }
    } catch (error) {
      console.error(error);
    }
  }

  return (
    <>

      <Card
        className="room-management-card"

        title={
          <TitleHead
            h1='Manage Rooms'
            h2='Room allocation, availability status & occupancy overview'
            extra={<Tag color="blue" style={{ fontSize: 14, padding: '0 8px' }}>
              Total Rooms: {rooms.length}
            </Tag>}
          />
        }
        extra={
          canCreateModule('add_room') && (
            <Button
              type="primary"
              icon={<PlusOutlined />}
              className="add-room-btn"
              onClick={() => navigate('/add-room')}
            >
              Add Room
            </Button>
          )
        }
      >
        <PageLayout
          left={
            <RoomList
              dataSource={rooms}
              selectedRow={selectedRoom}
              onRowSelect={setSelectedRoom}
            />
          }
          right={
            <RoomDetail
              room={selectedRoom}
              canEdit={canUpdateModule('edit_room')}
              canDelete={canDeleteModule(MODULE_KEY)}
              handleEditRoom={handleEditRoom}
              onEdit={(room) => {
                setSelectedRoom(room)
              }}
              handleDelete={handleDelete}
            />
          }
          leftWidth={50}
          rightWidth={50}
        />
      </Card>

    </>
  )
}

export default ManageRooms